export default {
    title: 'DM下載詳情'
}
